import { alert } from '@codeleap/modals'

export const comingSoon = () => {
  return alert.info({
    title: 'Coming soon',
    body: 'This feature is not yet available.',
  })
}

export function openMail(args: { email: string; subject?: string; body?: string }) {
  const { email, subject, body } = args
  try {
    const queryParams = []
    if (subject) queryParams.push(`subject=${encodeURIComponent(subject)}`)
    if (body) queryParams.push(`body=${encodeURIComponent(body)}`)

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
    const mailtoLink = `mailto:${email}${queryString}`

    const a = document.createElement('a')
    a.href = mailtoLink
    a.target = '_blank'
    a.click()
  } catch (error) {
    console.error('Error opening mail client:', error)
    alert.error({
      title: 'Error',
      body: 'Unable to open your mail client. Please try manually.',
    })
  }
}
